class DestroyOnExplode {}

export default DestroyOnExplode;
